import { Text } from "@dropbox/dig-components/typography";
import { ChatDiagnosticsStringViewer } from "@mirage/mosaics/ConversationAssistant/containers/ConversationAssistantPageContent/diagnostics/ChatDiagnosticsStringViewer";
import { ChatDiagnosticsViewerNode } from "@mirage/mosaics/ConversationAssistant/containers/ConversationAssistantPageContent/diagnostics/ChatDiagnosticsViewerNode";
import type {
  AnswersWorkflowProcess,
  AnswersWorkflowProcessValue,
} from "@mirage/service-dbx-api/service/grpc/context_engine_apiv2/gen/answers_pb";
import { Fragment, memo } from "react";

export const WorkflowProcessValuesUI = ({
  values,
  namePrefix,
}: {
  values: AnswersWorkflowProcessValue[];
  process: AnswersWorkflowProcess;
  namePrefix?: string;
}) => {
  const valuesGroupedByName: { [key: string]: AnswersWorkflowProcessValue[] } =
    {};
  const duplicates = [];

  values.forEach((value) => {
    const name = value.name || "";
    if (valuesGroupedByName[name]) {
      valuesGroupedByName[name].push(value);
      duplicates.push(name);
    } else {
      valuesGroupedByName[name] = [value];
    }
  });

  return (
    <>
      {Object.keys(valuesGroupedByName).map((name: string) => {
        const processValues: AnswersWorkflowProcessValue[] =
          valuesGroupedByName[name];
        const variableName = namePrefix ? `${namePrefix} ${name}` : name;
        if (processValues.length === 0) {
          return null;
        }
        return (
          <Fragment key={name}>
            {processValues.map((value, i) => {
              return (
                <ChatDiagnosticsViewerNode title={variableName} key={i}>
                  <WorkflowProcessValueUI value={value} />
                </ChatDiagnosticsViewerNode>
              );
            })}
          </Fragment>
        );
      })}
    </>
  );
};

interface WorkflowProcessValueUIProps {
  value: AnswersWorkflowProcessValue;
}
export const WorkflowProcessValueUI = memo(
  ({ value }: WorkflowProcessValueUIProps) => {
    return (
      <div>
        <Text size="xsmall" isBold tagName="div">
          <Text color="subtle" size="xsmall">
            Type:{" "}
          </Text>
          {cleanCaseName(value.value.case || "")}
        </Text>
        <ChatDiagnosticsStringViewer content={getContent(value)} />
      </div>
    );
  },
);
WorkflowProcessValueUI.displayName = "WorkflowProcessValueUI";

function safeJSONReplacer(key: string, value: unknown) {
  return typeof value === "bigint" ? value.toString() + "n" : value;
}

function cleanCaseName(caseName: string) {
  return caseName.replace(/^value/, "");
}

function getContent(value: AnswersWorkflowProcessValue) {
  // TODO: copy over all the specific cases from server debugger logic
  switch (value.value.case) {
    case "valueStr":
      return value.value.value;
    default:
      return JSON.stringify(value.value.value, safeJSONReplacer, 2);
  }
}
